const initialState = () => ({
  toast: {
    isActive: false,
    type: 'success',
    text: '',
    actionLabel: '',
    onActionClick: () => {},
  },
});

const getters = {
  get: (state) => state.toast,
};

const actions = {
  set({ commit }, toast) {
    commit('SET', toast);
  },
  reset({ commit }) {
    commit('RESET');
  },
};

const mutations = {
  SET(state, toast) {
    state.toast = {
      ...initialState().toast,
      isActive: true,
      ...toast,
    };
  },
  RESET(state) {
    state.toast = {
      ...initialState().toast,
    };
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
